import client from './client';

export interface RenderExportRecord {
  id: string;
  sceneId?: string | null;
  width: number;
  height: number;
  format: string;
  view?: string | null;
  bytes?: number | null;
  createdAt: string;
}

export async function recordRenderExport(body: {
  sceneId?: string;
  width: number;
  height: number;
  format: 'png' | 'jpeg';
  view?: string;
  bytes?: number;
}): Promise<RenderExportRecord> {
  const { data } = await client.post('/render-exports', body);
  return data;
}

export async function fetchRenderExports(limit = 20): Promise<{ items: RenderExportRecord[] }> {
  const { data } = await client.get('/render-exports', { params: { limit } });
  return data;
}
